export const SCORED_SLEEP_STUDY_UPLOAD_TYPE = "technician_scored";
export const UNSCORED_SLEEP_STUDY_UPLOAD_TYPE = "unscored";
export const UNSCORED_SLEEP_STUDY_COLLECTION = "sleepstudy";
export const SCORED_SLEEP_STUDY_COLLECTION = "scoredsleepstudy";

export const isSleepStudyCollection = (type) =>
  [UNSCORED_SLEEP_STUDY_COLLECTION, SCORED_SLEEP_STUDY_COLLECTION].includes(type);

export const getSleepStudyUploadCollection = (uploadType) =>
  uploadType === SCORED_SLEEP_STUDY_UPLOAD_TYPE
    ? SCORED_SLEEP_STUDY_COLLECTION
    : UNSCORED_SLEEP_STUDY_COLLECTION;

// The source collection determines the location, including older scored files
// that were uploaded to the original sleepstudy collection.
export const getSleepStudyFileCollection = (upload = {}) =>
  upload.fileCollection === SCORED_SLEEP_STUDY_COLLECTION
    ? SCORED_SLEEP_STUDY_COLLECTION
    : UNSCORED_SLEEP_STUDY_COLLECTION;

export const isScoredSleepStudyUpload = (upload = {}) =>
  upload.scoreUploadType === SCORED_SLEEP_STUDY_UPLOAD_TYPE ||
  upload.fileCollection === SCORED_SLEEP_STUDY_COLLECTION;

export const splitSleepStudyUploads = (uploads = []) => {
  const groups = { unscored: [], scored: [] };

  (Array.isArray(uploads) ? uploads : []).forEach((upload) => {
    if (!upload) return;
    // Older uploads without a marker stay in the existing unscored section.
    groups[isScoredSleepStudyUpload(upload) ? "scored" : "unscored"].push(upload);
  });

  return groups;
};
